var map = {
	"./1.png": 923,
	"./10.png": 924,
	"./11.png": 925,
	"./12.png": 926,
	"./13.png": 927,
	"./14.png": 928,
	"./15.png": 929,
	"./2.png": 930,
	"./3.png": 931,
	"./4.png": 932,
	"./5.png": 933,
	"./6.png": 934,
	"./7.png": 935,
	"./8.png": 936,
	"./9.png": 937,
	"./Background.png": 249,
	"./Countdown_0.png": 555,
	"./Countdown_1.png": 556,
	"./Countdown_2.png": 557,
	"./Countdown_3.png": 558,
	"./Countdown_4.png": 559,
	"./Countdown_5.png": 560,
	"./Onetowinlogo.png": 554,
	"./Top bar.png": 543,
	"./Wheel.png": 550,
	"./background_animations/Background 5_00000.png": 938,
	"./background_animations/Background 5_00001.png": 939,
	"./background_animations/Background 5_00002.png": 940,
	"./background_animations/Background 5_00003.png": 941,
	"./background_animations/Background 5_00004.png": 942,
	"./background_animations/Background 5_00005.png": 943,
	"./background_animations/Background 5_00006.png": 944,
	"./background_animations/Background 5_00007.png": 945,
	"./background_animations/Background 5_00008.png": 946,
	"./background_animations/Background 5_00009.png": 947,
	"./background_animations/Background 5_00010.png": 948,
	"./background_animations/Background 5_00011.png": 949,
	"./background_animations/Background 5_00012.png": 950,
	"./background_animations/Background 5_00013.png": 951,
	"./background_animations/Background 5_00014.png": 952,
	"./background_animations/Background 5_00015.png": 953,
	"./background_animations/Background 5_00016.png": 954,
	"./background_animations/Background 5_00017.png": 955,
	"./background_animations/Background 5_00018.png": 956,
	"./background_animations/Background 5_00019.png": 957,
	"./background_animations/Background 5_00020.png": 958,
	"./background_animations/Background 5_00021.png": 959,
	"./background_animations/Background 5_00022.png": 960,
	"./background_animations/Background 5_00023.png": 961,
	"./background_animations/Background 5_00024.png": 962,
	"./background_animations/Background 5_00025.png": 963,
	"./background_animations/Background 5_00026.png": 964,
	"./background_animations/Background 5_00027.png": 965,
	"./background_animations/Background 5_00028.png": 966,
	"./background_animations/Background 5_00029.png": 967,
	"./background_animations/Background 5_00030.png": 968,
	"./background_animations/Background 5_00031.png": 969,
	"./background_animations/Background 5_00032.png": 970,
	"./background_animations/Background 5_00033.png": 971,
	"./background_animations/Background 5_00034.png": 972,
	"./background_animations/Background 5_00035.png": 973,
	"./background_animations/Background 5_00036.png": 974,
	"./background_animations/Background 5_00037.png": 975,
	"./background_animations/Background 5_00038.png": 976,
	"./background_animations/Background 5_00039.png": 977,
	"./background_animations/Background 5_00040.png": 978,
	"./background_animations/Background 5_00041.png": 979,
	"./background_animations/Background 5_00042.png": 980,
	"./background_animations/Background 5_00043.png": 981,
	"./background_animations/Background 5_00044.png": 982,
	"./background_animations/Background 5_00045.png": 983,
	"./background_animations/Background 5_00046.png": 984,
	"./background_animations/Background 5_00047.png": 985,
	"./background_animations/Background 5_00048.png": 986,
	"./background_animations/Background 5_00049.png": 987,
	"./background_animations/Background 5_00050.png": 988,
	"./background_animations/Background 5_00051.png": 989,
	"./background_animations/Background 5_00052.png": 990,
	"./background_animations/Background 5_00053.png": 991,
	"./background_animations/Background 5_00054.png": 992,
	"./background_animations/Background 5_00055.png": 993,
	"./background_animations/Background 5_00056.png": 994,
	"./background_animations/Background 5_00057.png": 995,
	"./background_animations/Background 5_00058.png": 996,
	"./background_animations/Background 5_00059.png": 997,
	"./background_animations/Background 5_00060.png": 998,
	"./background_animations/Background 5_00061.png": 999,
	"./background_animations/Background 5_00062.png": 1000,
	"./background_animations/Background 5_00063.png": 1001,
	"./background_animations/Background 5_00064.png": 1002,
	"./background_animations/Background 5_00065.png": 1003,
	"./background_animations/Background 5_00066.png": 1004,
	"./background_animations/Background 5_00067.png": 1005,
	"./background_animations/Background 5_00068.png": 1006,
	"./background_animations/Background 5_00069.png": 1007,
	"./background_animations/Background 5_00070.png": 1008,
	"./background_animations/Background 5_00071.png": 1009,
	"./background_animations/Background 5_00072.png": 1010,
	"./background_animations/Background 5_00073.png": 1011,
	"./background_animations/Background 5_00074.png": 1012,
	"./background_animations/Background 5_00075.png": 1013,
	"./background_animations/Background 5_00076.png": 1014,
	"./background_animations/Background 5_00077.png": 1015,
	"./background_animations/Background 5_00078.png": 1016,
	"./background_animations/Background 5_00079.png": 1017,
	"./background_animations/Background 5_00080.png": 1018,
	"./background_animations/Background 5_00081.png": 1019,
	"./background_animations/Background 5_00082.png": 1020,
	"./background_animations/Background 5_00083.png": 1021,
	"./background_animations/Background_00000.png": 250,
	"./background_animations/Background_00001.png": 251,
	"./background_animations/Background_00002.png": 252,
	"./background_animations/Background_00003.png": 253,
	"./background_animations/Background_00004.png": 254,
	"./background_animations/Background_00005.png": 255,
	"./background_animations/Background_00006.png": 256,
	"./background_animations/Background_00007.png": 257,
	"./background_animations/Background_00008.png": 258,
	"./background_animations/Background_00009.png": 259,
	"./background_animations/Background_00010.png": 260,
	"./background_animations/Background_00011.png": 261,
	"./background_animations/Background_00012.png": 262,
	"./background_animations/Background_00013.png": 263,
	"./background_animations/Background_00014.png": 264,
	"./background_animations/Background_00015.png": 265,
	"./background_animations/Background_00016.png": 266,
	"./background_animations/Background_00017.png": 267,
	"./background_animations/Background_00018.png": 268,
	"./background_animations/Background_00019.png": 269,
	"./background_animations/Background_00020.png": 270,
	"./background_animations/Background_00021.png": 271,
	"./background_animations/Background_00022.png": 272,
	"./background_animations/Background_00023.png": 273,
	"./background_animations/Background_00024.png": 274,
	"./background_animations/Background_00025.png": 275,
	"./background_animations/Background_00026.png": 276,
	"./background_animations/Background_00027.png": 277,
	"./background_animations/Background_00028.png": 278,
	"./background_animations/Background_00029.png": 279,
	"./background_animations/Background_00030.png": 280,
	"./background_animations/Background_00031.png": 281,
	"./background_animations/Background_00032.png": 282,
	"./background_animations/Background_00033.png": 283,
	"./background_animations/Background_00034.png": 284,
	"./background_animations/Background_00035.png": 285,
	"./background_animations/Background_00036.png": 286,
	"./background_animations/Background_00037.png": 287,
	"./background_animations/Background_00038.png": 288,
	"./background_animations/Background_00039.png": 289,
	"./background_animations/Background_00040.png": 290,
	"./background_animations/Background_00041.png": 291,
	"./background_animations/Background_00042.png": 292,
	"./background_animations/Background_00043.png": 293,
	"./background_animations/Background_00044.png": 294,
	"./background_animations/Background_00045.png": 295,
	"./background_animations/Background_00046.png": 296,
	"./background_animations/Background_00047.png": 297,
	"./background_animations/Background_00048.png": 298,
	"./background_animations/Background_00049.png": 299,
	"./background_animations/Background_00050.png": 300,
	"./background_animations/Background_00051.png": 301,
	"./background_animations/Background_00052.png": 302,
	"./background_animations/Background_00053.png": 303,
	"./background_animations/Background_00054.png": 304,
	"./background_animations/Background_00055.png": 305,
	"./background_animations/Background_00056.png": 306,
	"./background_animations/Background_00057.png": 307,
	"./background_animations/Background_00058.png": 308,
	"./background_animations/Background_00059.png": 309,
	"./background_animations/Background_00060.png": 310,
	"./background_animations/Background_00061.png": 311,
	"./background_animations/Background_00062.png": 312,
	"./background_animations/Background_00063.png": 313,
	"./background_animations/Background_00064.png": 314,
	"./background_animations/Background_00065.png": 315,
	"./background_animations/Background_00066.png": 316,
	"./background_animations/Background_00067.png": 317,
	"./background_animations/Background_00068.png": 318,
	"./background_animations/Background_00069.png": 319,
	"./background_animations/Background_00070.png": 320,
	"./background_animations/Background_00071.png": 321,
	"./background_animations/Background_00072.png": 322,
	"./background_animations/Background_00073.png": 323,
	"./background_animations/Background_00074.png": 324,
	"./background_animations/Background_00075.png": 325,
	"./background_animations/Background_00076.png": 326,
	"./background_animations/Background_00077.png": 327,
	"./background_animations/Background_00078.png": 328,
	"./background_animations/Background_00079.png": 329,
	"./background_animations/Background_00080.png": 330,
	"./background_animations/Background_00081.png": 331,
	"./background_animations/Background_00082.png": 332,
	"./background_animations/Background_00083.png": 333,
	"./background_animations/Background_00084.png": 334,
	"./background_animations/Background_00085.png": 335,
	"./background_animations/Background_00086.png": 336,
	"./background_animations/Background_00087.png": 337,
	"./background_animations/Background_00088.png": 338,
	"./background_animations/Background_00089.png": 339,
	"./background_animations/Background_00090.png": 340,
	"./background_animations/Background_00091.png": 341,
	"./background_animations/Background_00092.png": 342,
	"./background_animations/Background_00093.png": 343,
	"./background_animations/Background_00094.png": 344,
	"./background_animations/Background_00095.png": 345,
	"./background_animations/Background_00096.png": 346,
	"./background_animations/Background_00097.png": 347,
	"./background_animations/Background_00098.png": 348,
	"./background_animations/Background_00099.png": 349,
	"./background_animations/Background_00100.png": 350,
	"./background_animations/Background_00101.png": 351,
	"./background_animations/Background_00102.png": 352,
	"./background_animations/Background_00103.png": 353,
	"./background_animations/Background_00104.png": 354,
	"./background_animations/Background_00105.png": 355,
	"./background_animations/Background_00106.png": 356,
	"./background_animations/Background_00107.png": 357,
	"./background_animations/Background_00108.png": 358,
	"./background_animations/Background_00109.png": 359,
	"./background_animations/Background_00110.png": 360,
	"./background_animations/Background_00111.png": 361,
	"./background_animations/Background_00112.png": 362,
	"./background_animations/Background_00113.png": 363,
	"./background_animations/Background_00114.png": 364,
	"./background_animations/Background_00115.png": 365,
	"./background_animations/Background_00116.png": 366,
	"./background_animations/Background_00117.png": 367,
	"./background_animations/Background_00118.png": 368,
	"./background_animations/Background_00119.png": 369,
	"./background_animations/Background_00120.png": 370,
	"./background_animations/Background_00121.png": 371,
	"./background_animations/Background_00122.png": 372,
	"./background_animations/Background_00123.png": 373,
	"./background_animations/Background_00124.png": 374,
	"./background_animations/Background_00125.png": 375,
	"./background_animations/Background_00126.png": 376,
	"./background_animations/Background_00127.png": 377,
	"./background_animations/Background_00128.png": 378,
	"./background_animations/Background_00129.png": 379,
	"./background_animations/Background_00130.png": 380,
	"./background_animations/Background_00131.png": 381,
	"./background_animations/Background_00132.png": 382,
	"./background_animations/Background_00133.png": 383,
	"./background_animations/Background_00134.png": 384,
	"./background_animations/Background_00135.png": 385,
	"./background_animations/Background_00136.png": 386,
	"./background_animations/Background_00137.png": 387,
	"./background_animations/Background_00138.png": 388,
	"./background_animations/Background_00139.png": 389,
	"./background_animations/Background_00140.png": 390,
	"./background_animations/Background_00141.png": 391,
	"./background_animations/Background_00142.png": 392,
	"./background_animations/Background_00143.png": 393,
	"./background_animations/Background_00144.png": 394,
	"./background_animations/Background_00145.png": 395,
	"./background_animations/Background_00146.png": 396,
	"./background_animations/Background_00147.png": 397,
	"./background_animations/Background_00148.png": 398,
	"./background_animations/Background_00149.png": 399,
	"./background_animations/Background_00150.png": 400,
	"./background_animations/Background_00151.png": 401,
	"./background_animations/Background_00152.png": 402,
	"./background_animations/Background_00153.png": 403,
	"./background_animations/Background_00154.png": 404,
	"./background_animations/Background_00155.png": 405,
	"./background_animations/Background_00156.png": 406,
	"./background_animations/Background_00157.png": 407,
	"./background_animations/Background_00158.png": 408,
	"./background_animations/Background_00159.png": 409,
	"./background_animations/Background_00160.png": 410,
	"./background_animations/Background_00161.png": 411,
	"./background_animations/Background_00162.png": 412,
	"./background_animations/Background_00163.png": 413,
	"./background_animations/Background_00164.png": 414,
	"./background_animations/Background_00165.png": 415,
	"./background_animations/Background_00166.png": 416,
	"./background_animations/Background_00167.png": 417,
	"./background_animations/Background_00168.png": 418,
	"./background_animations/Background_00169.png": 419,
	"./background_animations/Background_00170.png": 420,
	"./background_animations/Background_00171.png": 421,
	"./background_animations/Background_00172.png": 422,
	"./background_animations/Background_00173.png": 423,
	"./background_animations/Background_00174.png": 424,
	"./background_animations/Background_00175.png": 425,
	"./background_animations/Background_00176.png": 426,
	"./background_animations/Background_00177.png": 427,
	"./background_animations/Background_00178.png": 428,
	"./background_animations/Background_00179.png": 429,
	"./background_animations/Background_00180.png": 430,
	"./background_animations/Background_00181.png": 431,
	"./background_animations/Background_00182.png": 432,
	"./background_animations/Background_00183.png": 433,
	"./background_animations/Background_00184.png": 434,
	"./background_animations/Background_00185.png": 435,
	"./background_animations/Background_00186.png": 436,
	"./background_animations/Background_00187.png": 437,
	"./background_animations/Background_00188.png": 438,
	"./background_animations/Background_00189.png": 439,
	"./background_animations/Background_00190.png": 440,
	"./background_animations/Background_00191.png": 441,
	"./background_animations/Background_00192.png": 442,
	"./background_animations/Background_00193.png": 443,
	"./background_animations/Background_00194.png": 444,
	"./background_animations/Background_00195.png": 445,
	"./background_animations/Background_00196.png": 446,
	"./background_animations/Background_00197.png": 447,
	"./background_animations/Background_00198.png": 448,
	"./background_animations/Background_00199.png": 449,
	"./background_animations/Background_00200.png": 450,
	"./background_animations/Background_00201.png": 451,
	"./background_animations/Background_00202.png": 452,
	"./background_animations/Background_00203.png": 453,
	"./background_animations/Background_00204.png": 454,
	"./background_animations/Background_00205.png": 455,
	"./background_animations/Background_00206.png": 456,
	"./background_animations/Background_00207.png": 457,
	"./background_animations/Background_00208.png": 458,
	"./background_animations/Background_00209.png": 459,
	"./background_animations/Background_00210.png": 460,
	"./background_animations/Background_00211.png": 461,
	"./background_animations/Background_00212.png": 462,
	"./background_animations/Background_00213.png": 463,
	"./background_animations/Background_00214.png": 464,
	"./background_animations/Background_00215.png": 465,
	"./background_animations/Background_00216.png": 466,
	"./background_animations/Background_00217.png": 467,
	"./background_animations/Background_00218.png": 468,
	"./background_animations/Background_00219.png": 469,
	"./background_animations/Background_00220.png": 470,
	"./background_animations/Background_00221.png": 471,
	"./background_animations/Background_00222.png": 472,
	"./background_animations/Background_00223.png": 473,
	"./background_animations/Background_00224.png": 474,
	"./background_animations/Background_00225.png": 475,
	"./background_animations/Background_00226.png": 476,
	"./background_animations/Background_00227.png": 477,
	"./background_animations/Background_00228.png": 478,
	"./background_animations/Background_00229.png": 479,
	"./background_animations/Background_00230.png": 480,
	"./background_animations/Background_00231.png": 481,
	"./background_animations/Background_00232.png": 482,
	"./background_animations/Background_00233.png": 483,
	"./background_animations/Background_00234.png": 484,
	"./background_animations/Background_00235.png": 485,
	"./background_animations/Background_00236.png": 486,
	"./background_animations/Background_00237.png": 487,
	"./background_animations/Background_00238.png": 488,
	"./background_animations/Background_00239.png": 489,
	"./background_animations/Background_00240.png": 490,
	"./background_animations/Background_00241.png": 491,
	"./background_animations/Background_00242.png": 492,
	"./background_animations/Background_00243.png": 493,
	"./background_animations/Background_00244.png": 494,
	"./background_animations/Background_00245.png": 495,
	"./background_animations/Background_00246.png": 496,
	"./background_animations/Background_00247.png": 497,
	"./background_animations/Background_00248.png": 498,
	"./background_animations/Background_00249.png": 499,
	"./background_animations/Background_00250.png": 500,
	"./background_animations/Background_00251.png": 501,
	"./background_animations/Background_00252.png": 502,
	"./background_animations/Background_00253.png": 503,
	"./background_animations/Background_00254.png": 504,
	"./background_animations/Background_00255.png": 505,
	"./background_animations/Background_00256.png": 506,
	"./background_animations/Background_00257.png": 507,
	"./background_animations/Background_00258.png": 508,
	"./background_animations/Background_00259.png": 509,
	"./background_animations/Background_00260.png": 510,
	"./background_animations/Background_00261.png": 511,
	"./background_animations/Background_00262.png": 512,
	"./background_animations/Background_00263.png": 513,
	"./background_animations/Background_00264.png": 514,
	"./background_animations/Background_00265.png": 515,
	"./background_animations/Background_00266.png": 516,
	"./background_animations/Background_00267.png": 517,
	"./background_animations/Background_00268.png": 518,
	"./background_animations/Background_00269.png": 519,
	"./background_animations/Background_00270.png": 520,
	"./background_animations/Background_00271.png": 521,
	"./background_animations/Background_00272.png": 522,
	"./background_animations/Background_00273.png": 523,
	"./background_animations/Background_00274.png": 524,
	"./background_animations/Background_00275.png": 525,
	"./background_animations/Background_00276.png": 526,
	"./background_animations/Background_00277.png": 527,
	"./background_animations/Background_00278.png": 528,
	"./background_animations/Background_00279.png": 529,
	"./background_animations/Background_00280.png": 530,
	"./background_animations/Background_00281.png": 531,
	"./background_animations/Background_00282.png": 532,
	"./background_animations/Background_00283.png": 533,
	"./background_animations/Background_00284.png": 534,
	"./background_animations/Background_00285.png": 535,
	"./background_animations/Background_00286.png": 536,
	"./background_animations/Background_00287.png": 537,
	"./background_animations/Background_00288.png": 538,
	"./background_animations/Background_00289.png": 539,
	"./background_animations/Background_00290.png": 540,
	"./background_animations/Background_00291.png": 541,
	"./background_animations/Background_00292.png": 542,
	"./done.png": 553,
	"./drawing_id_window.png": 1022,
	"./drawingid_button.png": 544,
	"./edit.png": 548,
	"./fastforward.png": 1023,
	"./get_ready.png": 552,
	"./next_draw.png": 549,
	"./pause.png": 547,
	"./play.png": 545,
	"./replay.png": 546,
	"./ticker.png": 551
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 922;